<div class="collections-container">
  <div class="collections-header">
    <button class="back-button" (click)="onBackClick()" aria-label="Back to chat">
      <img src="assets/icons/collection-arrow.svg" alt="Back" class="back-arrow-icon">
    </button>
    <h1 class="collections-title">Collections</h1>
    <div class="add-container">
    <button disabled class="add-new-button" aria-label="Add New" >
      <img src="assets/icons/plus-icon.svg" alt="Add New" class="add-new-icon" />
       <span class="add-new-text">Add New</span>
    </button>
    <span class="tooltip-text">This feature is unavailable for this version.</span>
    </div>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <div class="loading-spinner"></div>
    <!-- <p class="loading-text">Loading collections...</p> -->
  </div>

  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-content">
      <i class="fas fa-exclamation-triangle error-icon"></i>
      <p class="error-message">{{ error }}</p>
      <button class="retry-button" (click)="loadCollections()">
        <i class="fas fa-refresh"></i>
        Retry
      </button>
    </div>
  </div>

  <div class="collections-list" *ngIf="!isLoading && !error">
    <app-collection-card 
      *ngFor="let collection of collections; let i =index; trackBy: trackByCollectionId"
      [collection]="collection"
      [collectionNumber]="i+1"
      (actionPerformed)="onCollectionAction($event)"
      (reloadCollections)="reloadCollections()">
    </app-collection-card>
  </div>

  <div class="empty-state" *ngIf="!isLoading && !error && collections.length === 0">
    <div class="empty-content">
      <img src="assets/icons/folder-icon.svg" alt="folder" class="folder-icon">
      <h3 class="empty-title">No collection found</h3>
      <p class="empty-message">You don't have any collection yet. Add your first collection to build knowledge base.</p>
      <button class="create-collection-btn">
        <img src="assets/icons/plus-icon.svg" alt="Add New" class="add-new-collection-icon" />
        Add collection
      </button>
    </div>
  </div>
</div>
